import isNil from 'lodash/isNil';
import has from 'lodash/has';
import { mapValues, pick } from 'lodash';
import { getResourceEntity } from 'js/lib/PipelineUtils';
import { filterWebhookResponseSourcesFromItems } from 'js/components/pipelines/FlowNodes/utils';

export default function getFlowItems(flow, { entities, branches }) {
  if (!flow) return [];
  const { flowNodes } = entities;
  const nodeId = flow.nodeKey;

  const branch =
    !isNil(nodeId) && has(branches, nodeId) ? branches[nodeId] : { items: [], edges: [] };

  return filterWebhookResponseSourcesFromItems(
    mapValues(pick(flowNodes, branch.items), (flowNode) => getResourceEntity(flowNode, entities)),
  );
}
